import { ERROR_ADD, ERROR_REMOVE, NOT_FOUND_ERROR_REMOVE } from '../actions/types';
//const INITIAL_STATE = [];
const INITIAL_STATE = {
  errors: [],
  notFound: null,
  notDriverledmodules: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR_ADD:
      switch (action.error.status) {
        case 404:
          return Object.assign({}, state, {
            notFound: action.error
          });
        default:
          //return [...state.concat(action.error)];
          return Object.assign({}, state, {
            errors: [...state.errors.concat(action.error)]
          });
      }
    case ERROR_REMOVE:
      return Object.assign({}, state, {
        errors: [...state.errors.filter((e) => e !== action.error)]
      });
    case NOT_FOUND_ERROR_REMOVE:
      return Object.assign({}, state, {
        notFound: null
      });

    default:
      return state;
  }
};